// Logic
import { Hall } from '@weblite/ts-action/hall'
import { changeHallInfo } from '$logic/hall'
// Common
import { OptionWithTextItem } from '$common/option-with-text-item/option-with-text-item'
import { Switch } from '$common/switch'
// Localization
import { t } from '$i18n'

interface Props {
  hall: Hall
  isGroup: boolean
}

export function HallSettingsOptions({ hall, isGroup }: Props) {
  return isGroup ? (
    <OptionWithTextItem
      primaryText={t('profile.hall.options.historyForNewMembers.title')}
      secondaryText={
        hall.showHistoryToNewMembers
          ? t('profile.hall.options.historyForNewMembers.visible')
          : t('profile.hall.options.historyForNewMembers.hidden')
      }
      icon={<Switch checked={hall.showHistoryToNewMembers} disabled={false} />}
      onClick={() =>
        changeHallInfo(hall.roomId, {
          showHistoryToNewMembers: !hall.showHistoryToNewMembers,
        })
      }
    />
  ) : null
}
